import {
  array,
  boolean,
  number,
  object,
  string,
  type infer as zInfer,
} from "zod";

export const getControlPortIntegration = {
  name: "getControlPortIntegration" as const,
  input: object({}),
  output: object({
    integration: object({
      apiKeyPreview: string(),
      createReturnsEnabled: boolean(),
      processReturnsEnabled: boolean(),
      returnReasonMap: array(
        object({
          redoReason: string(),
          controlPortReasonId: number(),
          controlPortReasonName: string(),
        }),
      ),
      defaultReturnReasonId: number().nullable(),
    }).nullable(),
    returnReasons: array(object({ id: number(), name: string() })),
  }),
};

export type GetControlPortIntegrationOutput = zInfer<
  typeof getControlPortIntegration.output
>;
